import React from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useGameSocket } from '../../providers/gameSocket.provider';
import LoadingContext from '../../contexts/LoadingContext';
import ToastContext from '../../contexts/ToastContext';
import { backendClient } from '../../services/MtcBackendClient';
import { parseError } from '../../utils/errorUtils';
import { Category } from '../../types/Category';
import { ChallengeContext } from '../../contexts/challenge.context';
import { ChallengeReadyPayload } from '../../types/socket.types';

export const ProtectedRoutes = () => {

    // Refs
    let isRendered = React.useRef<boolean>(false);
    let isConnected = React.useRef<boolean>(false);
    let isValidated = React.useRef<boolean>(false);

    // Contexts
    const { gameSocket } = useGameSocket();
    const { setLoading } = React.useContext(LoadingContext)
    const { openError } = React.useContext(ToastContext);
   
	// Hooks
    const { host } = useParams();
    const navigate = useNavigate();

    // State
    const [challenges, setChallenges] = React.useState<Category[]>([]);
    const [roundId, setRoundId] = React.useState<string>('');

    // Helpers
    const connectToPeer = (code: string) =>{
        isConnected.current = true;
        gameSocket?.emit('peer-connect', {
            code,
            type: 'client'
        });
    }
    const validateCode = async (code: string) =>{
        console.log("VALIDATING CODE...")
        
        try {
            setLoading(true)
            const data = await backendClient.validateCode(code);

            console.log(data.data);
            isValidated.current = true;
            //openSuccess(data?.message || "");
            connectToPeer(code);
            
        } catch (error) {
            setLoading(false)
            console.log(error);
            openError(parseError(error as any));
            navigate('/', { replace: true });
        }
    }

    const subscribe = () =>{
        gameSocket?.on('connect', ()=>{
            if (host && !isConnected.current && isValidated.current) {
                connectToPeer(host)
            }
        })

        gameSocket?.on('challenge-ready', (payload: ChallengeReadyPayload)=>{
            setChallenges(payload.challenges);
            setRoundId(payload.roundId);
            navigate(`/${host}`, { replace: true });
            console.log("CHALLENGE READY PROUTE!")
        })

        gameSocket?.on('disconnect', ()=>{
            isConnected.current = false;
        })
        
        gameSocket?.on('full', (isFull?: boolean)=>{
            setLoading(false);
            console.log("CONNECTED!")

            if (isFull) {
                openError("The room is full! \n Another client has already connected with the host");
                navigate('/', { replace: true })
            }
            
        })
    }

    // Effect
    React.useEffect(()=>{
        if (host && !isValidated.current) {
            validateCode(host);
        }
    },[host])

    React.useEffect(()=>{
        if (!isRendered.current) {
            subscribe();
            isRendered.current = true
        }
    },[host])



	return (
        <ChallengeContext.Provider
            value={{
                challenges,
                setChallenges,
                roundId
            }}
        >
            <Outlet/>
        </ChallengeContext.Provider>
	)
}